export const cookieLevels = {
  NECESSARY: 1,
  PERFORMANCE: 2,
  FUNCTIONAL: 3,
  ADVERTISING: 4,
};

export const STATUS = {
  WAITING_FOR_CONSENT: "waitingForConsent",
  EXPRESSED_CONSENT: "expressedConsent",
};
